import { useQuery } from "@tanstack/react-query";
import { Navigate } from "react-router-dom";
import { getMe } from "../api/Client";
import VerifyEmail from "../components/auth/VerifyEmail";

/**
 * Guards /verify-email the same way RequireAuth/RootGate guard their
 * routes: an already-verified session has no reason to sit on this page,
 * so it bounces straight to /learn instead of rendering the code form.
 */
export default function Verify() {
  const { data, isLoading } = useQuery({
    queryKey: ["me"],
    queryFn: getMe,
    refetchOnMount: "always",
  });

  if (isLoading) {
    return null;
  }

  if (data?.loggedIn && data.verified) {
    return <Navigate to={"/learn"} replace />;
  }

  return <VerifyEmail />;
}
